import { toMetadataAccount } from '../accounts.mjs';
import { GmaBuilder } from '../../../utils/GmaBuilder.mjs';
import { useOperation } from '../../../types/Operation.mjs';
import { toMetadata } from '../models/Metadata.mjs';

// -----------------
// Operation
// -----------------

const Key = 'FindNftsByMintListOperation';

/**
 * Finds multiple NFTs and SFTs by a given list of mint addresses.
 *
 * ```ts
 * const nfts = await metaplex
 *   .nfts()
 *   .findAllByMintList({ mints: [...] };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findNftsByMintListOperation = useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findNftsByMintListOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      commitment,
      programs
    } = scope;
    const {
      mints
    } = operation.input;
    const nftPdas = metaplex.nfts().pdas();
    const metadataPdas = mints.map(mint => nftPdas.metadata({
      mint,
      programs
    }));
    const metadataInfos = await GmaBuilder.make(metaplex, metadataPdas, {
      commitment
    }).get();
    scope.throwIfCanceled();
    return metadataInfos.map(account => {
      if (!account.exists) {
        return null;
      }
      try {
        return toMetadata(toMetadataAccount(account));
      } catch (error) {
        return null;
      }
    });
  }
};

export { findNftsByMintListOperation, findNftsByMintListOperationHandler };
//# sourceMappingURL=findNftsByMintList.mjs.map
